<footer class="main-footer">
    <div class="footer-row">
        <div class="footer-item ministeriologo">
            <img
                src="assets/images/logo-minagricultura-gobierno.png"
                alt="MinAgricultura"
                style="max-width: 202px; height: auto" />
        </div>
        <div class="footer-item footer_logo-upra">
            <img
                src="assets/images/Logo_UPRA_color.svg"
                alt="upra logo"
                class="upralogo" />
        </div>
    </div>
</footer>
